module.exports = __webpack_public_path__ + "static/media/179357.1520686d.jpg";